import { render, staticRenderFns } from "./HabilitarOficina.vue?vue&type=template&id=57f1b972&scoped=true"
import script from "./HabilitarOficina.vue?vue&type=script&lang=js"
export * from "./HabilitarOficina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f1b972",
  null
  
)

export default component.exports